<template>
    <div class="container">
        <div class="validity-form-root">
            <h3 class="title"> {{name}} </h3>
            <div class="export-container" v-if="modalParams.selectUnit">
                <label for="export-unity">{{$t('unit')}}:</label>
                <div class="select-container">
                    <v-select
                        class="restrinctions-select-autocomplete"
                        multiple
                        :disabled="view.exportData.checkedFilial"
                        :options="view.exportData.filial"
                        :getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
                        :clearable="false"
                        v-model="view.exportData.selectedFilial"
                    ></v-select>
                    <div class="input-container">
                        <input
                            class="allCheck"
                            type="checkbox"
                            id="scales"
                            name="scales"
                            :checked="view.exportData.checkedFilial"
                            @click="allFiliClicked"
                        />
                        <span>{{$t('all')}}</span>
                    </div>
                </div>
            </div>
            <div class='button-div'>
                <button
                    class="button outline modal-button"
                    style="line-height: .9rem"
                    @click="hideModal"> <i class="fas fa-times"></i
                >
                    {{$t('cancel')}}
                </button>
                <button
                    class="button modal-button"
                    style="line-height: 1.1rem"
                    @click="saveExport"
                >
                    <span v-show="showLoad"> {{$t('save')}} </span> 
                    <img v-show="!showLoad" :src="view.exportData.loadGif" style="height: 33px; margin: auto;"/>
                </button>
            </div>
        </div>
        <modal
            name="message"
            :height="'auto'"
            :clickToClose="false"
        >
            <message-pop-up
                :modal="this.modal"
                :title="view.message.title"
                :message="view.message.message"
                :nameModal="'message'"
            />
        </modal>
    </div>
</template>

<script>
import vSelect from "vue-select";
import RestrictionProvider from '@/application/providers/RestrictionsProvider';
import MessagePopUp from '@/components/src/MessagePopUp';
import { t } from 'i18next';

export default {
    name: 'ExportModal',
    props: {
        modalParams: {
            type: Object,
            default: () => ({})
        },
        showLoad: {
            type: Boolean,
            default: true
        },
        modal: {
            type: Object
        },
        name: {
            type: String
        }
    },
    components: {
        "v-select": vSelect,
        "message-pop-up": MessagePopUp
    },
    data() {
        return {
            view: {
                exportData: {
                    filial: [],
                    selectedFilial: null,
                    checkedFilial: false,
                    loadGif: require("../../../static/loading_gif_export.gif")
                },
                modalParams: {
                    selectUnit: true,
                },
                message: {
                    title: '',
                    message: ''
                }
            }
        }
    },
    mounted() {
        this.resetObjectModal();
        this.getFiliaOper();
    },
    methods: {
        getFiliaOper: function() {
            RestrictionProvider.getFiliaOper().then((filial) => {
                this.view.exportData.filial = filial;
            });
        },
        resetObjectModal: function() {
            this.view.exportData.selectedFilial = null;
        },
        hideModal: function() {
            this.resetObjectModal();
            this.modal.hide('export-modal');
        },
        allFiliClicked: function() {
            this.view.exportData.selectedFilial = null;
            this.view.exportData.checkedFilial = !this.view.exportData.checkedFilial;
        },
        saveExport: function() {
            if(this.isValidField()) {
                this.$emit('saveExport', this.view);
            } else {
                this.showLoad = true;
            }
        },
        isValidField: function() {
            if (!this.view.exportData.checkedFilial && this.view.exportData.selectedFilial == null) {
                this.showMessage(t('invalid_data'), t('unit_field_not_selected'));
                return false;
            }
            return true;
        },
        showMessage: function(title, message) {
            this.view.message.title = title;
            this.view.message.message = message;
            this.$forceUpdate();
            this.modal.show('message');
        }
    }
}
</script>

<style lang="less" scoped>

.modal-button{
	font-size: .9rem;
	padding: 6px 13px;
	&.disabled{
		background-color: gray;
    	pointer-events: none;
	}
}

    .validity-form-root {
        width: calc(100% - 30px);
		margin: 15px;
		margin-bottom: 30px;

        .title {
            margin-bottom: 5px;
			margin-left: 10px;
        }

        .export-container {
			display: inline-block;
			margin: 10px;
			text-align: left;
			font-size: .9rem;
			width: calc(100% - 45px);
        }

        .select-container {
            display: grid;
            grid-template-columns: 80% 20%;

            .input-container {
                margin: auto;

                input, span {
                    vertical-align: middle;
                    display: inline-block;
                }
            }
        }

        .allCheck {
            position: relative;
            cursor: pointer;
            height: 20px;
            width: 20px;
        }

        .allCheck:before {
            content: "";
            display: block;
            position: absolute;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
            background-color: white;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:before {
            content: "";
            display: block;
            position: absolute;
            margin: auto;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
            background-color: #dc143d;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:after {
            content: "";
            display: block;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            position: absolute;
            top: 4px;
            left: 9px;
        }

        .button{
            min-width: 100px;
            padding: 6px 15px;
            margin: auto 3px;

            &.ghost{
                background-color: white;
                box-shadow: none;
                color: #dc143d;
                border: 1px solid #dc143d;
                padding: 5px 14px;

                &:hover{
                    color: #212146;
                    border: 1px solid #212146;
                }
            }
        }
        .vs_dropdown-menu {
            height: 110px;
        }
    }
</style>